import React, { useEffect } from 'react'
import { useFormik } from 'formik'
import { getUserId } from '../../helpers/auth'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import { Button, Input, Modal } from 'antd'
import Loader from '../../pages/pages/loader'
import { useCreateBlockingDomainCategoryMutation, useUpdateBlockingDomainCategoryByIdMutation } from '../../redux/apis/blockingDomainsManagement/bDCategoriesApiSlice'

const EditCreateBlockingDomainCategory = ({ state, open, setOpen, record }) => {
  const [
    updateService,
    { isLoading: isUpdating, isSuccess: SuccessUpdate, error: errorUpdate }
  ] = useUpdateBlockingDomainCategoryByIdMutation()
  const [
    addService,
    { isLoading: isAdding, isSuccess: SuccessAdd, error: errorAdd }
  ] = useCreateBlockingDomainCategoryMutation()

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      category_name: record?.category_name || '',
      last_updated_by: getUserId()
    },

    validationSchema: Yup.object({
      category_name: Yup.string().required('Please Enter Category Name'),
    }),

    onSubmit: async values => {
      const formData = new FormData()
      for (let key in values) {
        formData.append(key, values[key])
      }

      try {
        if (state === 'edit') {
          await updateService({
            body: formData,
            id: record?.id
          }).unwrap()
        } else if (state === 'create') {
          await addService(formData).unwrap()
        }
      } catch (err) {
        console.error(err)
      }
    }
  })

  useEffect(() => {
    if (errorAdd?.data) {
      const errorMessages = Object.values(errorAdd.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    } else if (errorUpdate?.data) {
      const errorMessages = Object.values(errorUpdate.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [errorAdd, errorUpdate])

  useEffect(() => {
    console.log(SuccessAdd, SuccessUpdate)
    if (SuccessAdd && state === 'create') {
      toast.success('Blocking Domain Category created successfully!')
      setOpen(false)
    } else if (SuccessUpdate && state === 'edit') {
      toast.success('Blocking Domain Category updated successfully!')
      setOpen(false)
    }
  }, [state, SuccessAdd, SuccessUpdate])

  return (
    <Modal
      className='customModal'
      open={open}
      title={state === 'edit' ? `Edit Blocking Domain Category` : 'Create Blocking Domain Category'}
      onCancel={() => setOpen(false)}
      footer={[
        <Button key='back' onClick={() => setOpen(false)}>
          Cancel
        </Button>,
        <Button
          key='submit'
          type='primary'
          onClick={() => {
            if (Object.keys(validation.errors).length !== 0) {
              Object.keys(validation.errors).map(key => {
                toast.error(validation.errors[key])
              })
              return
            }
            validation.handleSubmit()
          }}
        >
          Submit
        </Button>
      ]}
    >
      <Loader isLoading={isAdding || isUpdating} />

      <div className=' mb-3'>
        <label className="form-label">Domain Category</label>
        <Input
          type='text'
          name='category_name'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.category_name}
        />
        {validation.touched.category_name && validation.errors.category_name ? (
          <p className='text-danger'>{validation.errors.category_name}</p>
        ) : null}
      </div>
     
    </Modal>
  )
}

export default EditCreateBlockingDomainCategory
